/*
 * Public API Surface of dynamic-theme-lib
 */

export * from './lib/dynamic-theme-lib.service';
export * from './lib/dynamic-theme-lib.component';
export * from './lib/dynamic-theme-lib.module';
export * from './lib/directives/background-colour.directive';
export * from './lib/directives/text-colour.directive';
export * from './lib/services/colour.service';
